import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_s4mtr37bpt: FaireBrandEntity = {
  token: "b_s4mtr37bpt",
  type: "brand",
  name: "Hazeltine Scent Company",
  avatarUrl:
    "https://cdn.faire.com/fastly/529d80a05cd4890f99b039773dd3f6673f7abd3d224f21cc156149af1252cf9a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/ef50d32e539d27bb901ddf3eeed2a104ab94658599f7d4cd4e392d264a6775c5.png",
  logoUrl:
    "https://cdn.faire.com/fastly/529d80a05cd4890f99b039773dd3f6673f7abd3d224f21cc156149af1252cf9a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ef50d32e539d27bb901ddf3eeed2a104ab94658599f7d4cd4e392d264a6775c5.png",
  location: "New Orleans, LA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 10,
  isInsider: true,
  description:
    "Of all the senses, scent has the greatest power to transport us to a different time and place. When we smell something, our scent receptors send a signal directly to the limbic system, the area of the brain responsible for memory and emotion, bypassing the route through which sight, sound, and touch travel. This means, for example, that smelling a rose can trigger memories and emotions far more effectively than hearing the word \"rose\" or seeing a picture of one.\n\nHazeltine was created to harness this power and satisfy the longing that accompanies nostalgia—we can't travel back in time yet, but in the meantime we can vibe out through good smells. All of our scents are drawn from fond memories and historical anecdotes, and we're perpetually inspired by unexpected intersections of human behavior and the natural environment. We also think it's cool when your house smells good. \n\nAll Hazeltine products are thoughtfully hand-crafted in New Orleans.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:24.990Z",
    importedBy: "entity-db-cli",
  },
};
